import { useQuery } from '@apollo/client'
import { GetClientCartItemCountDocument } from '@shared/gql/document-nodes'

export const useClientCartItemCount = (id: string): number => {
  const { data } = useQuery(GetClientCartItemCountDocument, { variables: { id } })
  return data?.cartItem?.itemCount ?? 0
}
